import _Vue from "vue";
import axios, {Axios} from "axios";
import app from "@/main";
import {Mixins} from "@/plugins/uyap-plugin/takip_ac/Mixins";
import * as xml2js from "xml2js";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {store} from "@/store";
import {v4 as uuidv4} from 'uuid';
import {promptForPin, promptForPinSimple} from './utils/pin-modal';

const imzaciUrl = 'https://imza.eicrapro.com:6090/';
const proxyBaseUrl = 'https://imza.eicrapro.com:';
const uyapSignerUrl = 'https://imza.eicrapro.com:6057';
const uyapSignerBedestenUrl = 'https://imza.eicrapro.com:6065';
const avukatBetaUrl = 'https://imza.eicrapro.com:6099';
const avukatUyapUrl = 'https://imza.eicrapro.com:6081';
// Yeni imzalama uygulaması (localhost:5975) proxy adresi
const newSignerUrl = 'https://imza.eicrapro.com:6075';

// UTF-8 aware base64 decoder
function base64ToUtf8(value: string): string {
    try {
        const decoded = atob(value);
        const bytes = new Uint8Array(decoded.length);
        for (let i = 0; i < decoded.length; i++) {
            bytes[i] = decoded.charCodeAt(i);
        }
        // TextDecoder kullan (modern tarayıcılarda mevcut)
        if (typeof TextDecoder !== 'undefined') {
            const decoder = new TextDecoder('utf-8');
            return decoder.decode(bytes);
        }
        // Fallback: Manuel UTF-8 decode
        let result = '';
        let i = 0;
        while (i < bytes.length) {
            const byte1 = bytes[i++];
            if (byte1 < 0x80) {
                result += String.fromCharCode(byte1);
            } else if (byte1 < 0xE0) {
                const byte2 = bytes[i++];
                result += String.fromCharCode(((byte1 & 0x1F) << 6) | (byte2 & 0x3F));
            } else if (byte1 < 0xF0) {
                const byte2 = bytes[i++];
                const byte3 = bytes[i++];
                result += String.fromCharCode(((byte1 & 0x0F) << 12) | ((byte2 & 0x3F) << 6) | (byte3 & 0x3F));
            } else {
                const byte2 = bytes[i++];
                const byte3 = bytes[i++];
                const byte4 = bytes[i++];
                const codePoint = ((byte1 & 0x07) << 18) | ((byte2 & 0x3F) << 12) | ((byte3 & 0x3F) << 6) | (byte4 & 0x3F);
                result += String.fromCodePoint(codePoint);
            }
        }
        return result;
    } catch (_) {
        return value;
    }
}

export enum UYAP_PLATFORM_SOCKET {
    ARABULUCU_PORTAL = 6080,
    ARABULUCU_PORTAL_URL = "arabulucu.uyap.gov.tr",
    AVUKAT_PORTAL = 6081,
    AVUKAT_PORTAL_URL = "avukat.uyap.gov.tr",
}

class ImzaClient {
    simulator = false;
    imzaLoginWaiting = false;
    waitingFailMessage = "Bekleyen bir giriş isteği mevcut.";
    myuuid = uuidv4();
    licenseKey = "NRbfdG5VRh25x8rxs+8L8z9X3YTSndyqzXkhQIlbXZRboRJypUaZRIj56UAUAvamES9cs9xV1wkElxODkl/4DHMOJukkJpeMkMI2sjdX2tmMNJOypPzVdr0mKQe9JQin890XaUmbU1cCpUdZruvmlumTixbKABvx05sueWWs83iFoezLIV7TTY7fP/N8J/Rgoi4SH+LxxVp513Ww3FG67jF88XsEiIxb+g1v4h5EDHXCEnaalStjGOoBUDyWCq0IB+f09Fa5asSxfVRuefsCLL8pEtUE7c4+QUft0Oq/l9sHSMwr8tNPLcN3yPbSY1uej5N2inTsEwX5eux0IYSDkQ==";
    availableCardsPromise: Promise<any>|null = null;
    betaLoginPromise: Promise<any>|null = null;

    private ensureTcknInSession(): string | null {
        let t = sessionStorage.getItem('tckn');
        const isValid = (val: any) => typeof val === 'string' && /^\d{11}$/.test(val);
        if (!isValid(t)) {
            try {
                const s = store?.getters?.userData?.kimlik_no;
                if (isValid(String(s))) {
                    t = String(s);
                    sessionStorage.setItem('tckn', t);
                } else {
                    t = null;
                }
            } catch (_e) {
                t = null;
            }
        }
        return t;
    }

    setSimulator() {
        this.simulator = true;
    }

    heartbeat() {
        console.log('heartbeat() fonksiyonu başlatıldı');
        const xml = '<root><auth><token></token><hash></hash></auth><data></data></root>';
        return new Promise(async (s, f) => {
            if (this.simulator) {
                return s("");
            }
            try {
                let data = await axios.post(imzaciUrl + 'xml/heartbeat', {xml: xml}, {
                    withCredentials: true
                });
                return s(data);
            } catch (e) {
                //console.log('fail');
                return f(e);
            }
        });
    }
    async setApiCookiesToImza(){
        try{
            let tenant = await store.dispatch('tenantData');
            let apiType: string = "";
            switch (process.env.VUE_APP_API_TARGET) {
                case 'http://localhost':
                    apiType = "local";
                    break;
                case 'http://localhost:4000':
                    apiType = "local";
                    break;
                case 'https://apicloudicra.neova.com.tr':
                    apiType = "neova";
                    break;
                case 'https://apicloudtest.zirve-bilgisayar.com':
                    apiType = "test"
                    break;
                case 'https://apibeta.zirve-bilgisayar.com':
                    apiType = "beta"
                    break;
                case 'https://apicloud.zirve-bilgisayar.com':
                    apiType = "canli"
                    break;
                default:
                    apiType = "local";
                    break;
            }

            // Session storage'a TCKN'yi kaydet (imza doğrulama için)
            if (store.getters.userData && store.getters.userData.kimlik_no) {
                sessionStorage.setItem('tckn', store.getters.userData.kimlik_no);
                console.log('TCKN sessionStorage\'a kaydedildi:', store.getters.userData.kimlik_no);
            }

            const cookieSetUrl = encodeURI(proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL + '/setConfig?token=' + 'Bearer ' + store.getters.accessToken + '&tenant=' + JSON.stringify(tenant) + '&tckn=' + store.getters.userData.kimlik_no + '&apiType=' + apiType);
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
            _Vue.prototype.$socket.client.emit("updateToken");
            return true;
        }catch (e) {
            throw new Error(e);
        }
    }


    async setCookieToImza() {
        if (window.sessionStorage.hasOwnProperty("INJECT_JSESSIONID")) {
            let jsessionId = window.sessionStorage.getItem("INJECT_JSESSIONID");
            const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/cookie?JSESSIONID=' + jsessionId + ';SameSite=None;Secure';
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
        }
    }

    async changePlayerStatus(status: PlayerDurum) {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/putTaskPlayerStatus?' + status;
        await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    async getPlayerStatus() {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/getTaskPlayerStatus';
        return await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    async login(uyapPlatform: UYAP_PLATFORM_SOCKET) {
        try {
            if (this.imzaLoginWaiting == true)
                throw new Error(this.waitingFailMessage);
            this.imzaLoginWaiting = true;
            let authorizationCodeResponse = await axios.post(imzaciUrl + 'xml/session');
            window.sessionStorage.setItem("uyapAuthorizationCode", authorizationCodeResponse.data);
            let platform = UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL_URL;
            if (uyapPlatform == UYAP_PLATFORM_SOCKET.ARABULUCU_PORTAL)
                platform = UYAP_PLATFORM_SOCKET.ARABULUCU_PORTAL_URL;
            let uyapLoginResponse = await axios.get(imzaciUrl + 'uyapLogin?code=' + authorizationCodeResponse.data + '&platform=' + platform);
            let cookies = uyapLoginResponse.data;
            //@ts-ignore
            let jsessionId = cookies.find(c => c.indexOf("JSESSIONID") >= 0);
            const cookieSetUrl = proxyBaseUrl + uyapPlatform.toString() + '/cookie?' + cookies.join("; ") + ';SameSite=None;Secure';
            window.sessionStorage.setItem("JSESSIONID", jsessionId);
            app.$uyapHelper.setCookie("JSESSIONID", jsessionId.replace("JSESSIONID=", ""), 1);
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
            app.$socket.client.emit("uyapcookies", {
                cookies: cookies,
            });
            let counter = 0;
            const checkSession = () => {
                app.$uyap.KullaniciBilgileri().run({}).then(async avukat => {
                    this.imzaLoginWaiting = false;
                    app.$store.commit('setUyapAvukatBilgileri', avukat);
                    try {
                        const bakiyeRes = await app.$uyap.AvukatBakiyeSorgula().run({});
                        app.$store.commit('setUyapAvukatBakiye', bakiyeRes.value);
                        const sorguBakiyeRes = await app.$uyap.SorguBakiyesi().run({});
                        app.$store.commit('setUyapSorguBakiye', String(sorguBakiyeRes.sorguBakiye));
                    } catch {
                        /* bakiye alınamazsa sessizce devam et */
                    }
                    return avukat;
                }).catch((avukatErr) => {
                    // eslint-disable-next-line no-console
                    console.log("CATCH AVUKAT", avukatErr);
                    if (counter > 5) {
                        this.imzaLoginWaiting = false;
                        throw new Error('UYAP oturumuna erişilemedi.');
                    } else {
                        counter++;
                        window.setTimeout(() => {
                            checkSession();
                        }, 3000)
                    }
                })
            }
            checkSession();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("imza login CATCH", e);
            this.imzaLoginWaiting = false;
            throw new Error(e.message);
        }
    }

    async betaLoginImzalayici() {
        try {
            //throw new Error("GÜNCELLEME YAPILIYOR");
            if (this.imzaLoginWaiting == true)
                throw new Error(this.waitingFailMessage);
            this.imzaLoginWaiting = true;

            const licenseKey = "hBx7PnsAGYo4q4QUSwDEQabM/Ky+bk2uxoKi2aIzBMw=";
            let certificatesResponse = await axios.post(uyapSignerUrl + "/certificates", {
                license : licenseKey
            });
            // eslint-disable-next-line no-console
            console.log(certificatesResponse);

            //certifikaları aldık 2 tane olabilir biz ilkini alıyoruz..
            let selectedCertificate = certificatesResponse.data.data[0].certs[0];
            let certificateResponse = await axios.post(uyapSignerUrl + "/certificate", {
                certificateId: selectedCertificate.id,//"x509-02000000-1fc3ce82e47ff4020caa4e0c9edd4a6bec4b4a5700",
                license:licenseKey,
                providerId : selectedCertificate.providerId
            });


            let tckn = selectedCertificate.subjectSerial;
            let serial = selectedCertificate.serial;
            // eslint-disable-next-line no-console
            console.log('Sertifika TCKN:', tckn);
            const sessionTcknRaw = this.ensureTcknInSession();
            console.log('SessionStorage TCKN:', sessionTcknRaw);
            console.log('Sertifika serial:', serial);

            // TCKN kontrolünü daha esnek yap - sessionStorage'da TCKN yoksa atla
            const normalize = (v: string | null | undefined) => v ? v.replace(/\D/g, '') : null;
            const sessionTckn = normalize(sessionTcknRaw);
            const certTckn = normalize(tckn);
            if (sessionTckn && certTckn && sessionTckn !== certTckn) {
                console.error('Normal İmza TCKN uyuşmazlığı! SessionStorage:', sessionTckn, 'Sertifika:', certTckn);
                throw {type: 'unauthorized', message: 'İzinsiz İmza'};
            } else if (!sessionTckn) {
                console.warn('SessionStorage\'da TCKN bulunamadı, normal imza kontrolü atlanıyor');
            } else {
                console.log('Normal imza TCKN kontrolü başarılı');
            }
            let pinCode = localStorage.getItem(serial);
            if (!pinCode || pinCode == "undefined" || pinCode == undefined) {
                const ownerInfo = selectedCertificate.issuer + " --- " + selectedCertificate.subject;
                const deger = await promptForPinSimple(ownerInfo);

                if (!deger) {
                    throw new Error('İmza işlemi iptal edildi');
                }
                localStorage.setItem(serial, deger);
                pinCode = deger;
            }

            //https://bedesten.adalet.gov.tr/izo/api/v1/sign/sign

            let bedestenSignResponse = await axios.post(uyapSignerBedestenUrl + "/izo/api/v1/sign/sign", {
                cert:certificateResponse.data.data,
                profile:"CAdES",
                subProfile:"BES",
                type:"ATTACHED",
                policy:"NONE",
                device:"TOKEN",
                counterSignature:"PARALLEL",
                documentB64:"QmlyIEfDvG4gSGVya2VzIEZlbmVyYmFoY2VsaSBPbGFjYWs=",
                validateAfter: true
            });

            let signResponse = await axios.post(uyapSignerUrl + "/sign", {
                certificateId:selectedCertificate.id,
                contentB64:bedestenSignResponse.data.data.dataToSign,
                license:licenseKey,
                password:pinCode,
                providerId:selectedCertificate.providerId,
            });

            let bedestenMergeResponse = await axios.post(uyapSignerBedestenUrl + "/izo/api/v1/sign/merge", {
                signedData:signResponse.data.data,
                txId:bedestenSignResponse.data.data.txId,
            });

            let newAxios = new Axios({
                withCredentials: true,
            });
            await newAxios.get(avukatUyapUrl+'/clearCookies');
            // set-cookie
            let setCookieRes = await newAxios.get(avukatUyapUrl+'/web1.uyap', {
                params: {
                    signature:bedestenMergeResponse.data.data.signature,
                    txId: bedestenMergeResponse.data.data.txId,
                }
            });
            window.sessionStorage.setItem("JSESSIONID", setCookieRes.headers.cookie);
            // kullanilmadigi icin kapatildi
            // let setCookieResData = JSON.parse(setCookieRes.data);
            await newAxios.post(avukatUyapUrl+'/login.uyap', {});
            let counter = 0;
            const checkSession = () => {
                app.$uyap.KullaniciBilgileri().run({}).then(async avukat => {
                    this.imzaLoginWaiting = false;
                    app.$store.commit('setUyapAvukatBilgileri', avukat);
                    try {
                        const bakiyeRes = await app.$uyap.AvukatBakiyeSorgula().run({});
                        app.$store.commit('setUyapAvukatBakiye', bakiyeRes.value);
                        const sorguBakiyeRes = await app.$uyap.SorguBakiyesi().run({});
                        app.$store.commit('setUyapSorguBakiye', String(sorguBakiyeRes.sorguBakiye));
                    } catch {
                        /* bakiye alınamazsa sessizce devam et */
                    }
                    return avukat;
                }).catch((avukatErr) => {
                    // eslint-disable-next-line no-console
                    console.log("CATCH AVUKAT", avukatErr);
                    if (counter > 5) {
                        this.imzaLoginWaiting = false;
                        throw new Error('UYAP oturumuna erişilemedi.');
                    } else {
                        counter++;
                        window.setTimeout(() => {
                            checkSession();
                        }, 3000)
                    }
                })
            }
            checkSession();
            // let cookies = await newAxios.get(avukatUyapUrl+'/getCookies');
            // let cookiesArr = JSON.parse(cookies.data).cookies.split('; ');
            // let jsessionId = cookiesArr.find((x:string)=>x.includes('JSESSIONID'));
            // window.sessionStorage.setItem("JSESSIONID", jsessionId);
            // app.$uyapHelper.setCookie("JSESSIONID", jsessionId.replace("JSESSIONID=", ""), 1);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("ERROR", e);
            if (e?.type == "pin")
                localStorage.removeItem(e.serialNumber);
            if (e?.type == "unauthorized") {
                this.sendImzaMessage({
                    title: "İzinsiz İmza",
                    text: "Hesabınızda kayıtlı TC kimlik numarası ile e-İmza kartındaki TC kimlik numarası  uyuşmamaktadır. Lütfen kendi hesabınızla giriş yapın ve size ait e-İmza kartını kullanın. Sorunun devam ettiğini düşünüyorsanız, Cloud ekranında Ctrl + Shift + R tuşlarına basarak sayfayı yenileyebilir ve tekrar deneyebilirsiniz. ",
                    icon: "warning",
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                });
            } else if (e.message && e.message.includes("Failed to execute 'atob'")) {
                this.sendImzaMessage({
                    title: "İmza Kartı Bulunamadı",
                    text: "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun.",
                    icon: "warning",
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                })
            } else {
                this.sendImzaMessage({
                    title: e.message,
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                });
            }
            this.imzaLoginWaiting = false;
            throw new Error(e.message);
        }
    }

    sendImzaMessage(msg: any){
        _Vue.prototype.$socket.client.emit("imzaMessage",msg);
    }

    async checkArkSignerRunning(){
        try{
            await axios.get(newSignerUrl + '/api/v1/signature/getCertificates');
        }catch (e) {
            throw new Error("UYAP E-İmza Programı açık değil veya hata oluştu lütfen UYAP E-İmza Programını açınız.")
        }
    }


    private async sleeping(ms: number): Promise<void> {
        //console.log("sleeping...");
        await new Promise((res) => setTimeout(res, ms));
    }

    async availableCards(){
        try{
            if (this.availableCardsPromise) {
                return this.availableCardsPromise;
            }
            this.availableCardsPromise = (async () => {
                try {
                    await this.checkArkSignerRunning();
                    // Yeni imzalama uygulaması API'si
                    const certsResponse = await axios.get(newSignerUrl + '/api/v1/signature/getCertificates');
                    const responseData = certsResponse.data;

                    if (!responseData?.data || !Array.isArray(responseData.data)) {
                        throw new Error('Sertifika listesi alınamadı.');
                    }

                    // Her terminal için sertifikaları düzleştir
                    const cardList: any[] = [];
                    for (const terminal of responseData.data) {
                        if (!Array.isArray(terminal.certificates)) continue;
                        for (const cert of terminal.certificates) {
                            cardList.push({
                                // Eski yapıyla uyumluluk için sarmalayıcı
                                terminal: terminal.terminal,
                                serialNumber: terminal.serialNumber,
                                certificate: cert
                            });
                        }
                    }

                    store.commit('setAvailableCardList', cardList);
                    return cardList;

                } finally {
                    this.availableCardsPromise = null;
                }
            })();

            return this.availableCardsPromise;

        }catch (e) {
            console.log("availableCards error", e);
            this.sendImzaMessage({
                title: "UYAP IMZA UYGULAMASI HATA!",
                text:  e.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Tamam'
            });
        }
    }
    getPinCodes(){
        if(localStorage.hasOwnProperty("pinCodes")){
            //@ts-ignore
            return JSON.parse(localStorage.getItem("pinCodes"));
        }else{
            this.setPinCodes([]);
            return [];
        }
    }
    setPinCodes(val: any){
        localStorage.setItem("pinCodes",JSON.stringify(val));
    }
    async betaLogin() {
        console.log("this.betaLoginPromise",this.betaLoginPromise);
        // Eğer zaten çalışıyorsa mevcut Promise’i döndür
        if (this.betaLoginPromise) {
            return this.betaLoginPromise;
        }
        // Fonksiyonun gerçek işini yapan Promise'i oluştur
        this.betaLoginPromise = (async () => {
            try {

                if(this.isMobilImza()){
                    await axios.post('https://imza.eicrapro.com:6090/focus');
                    this.betaLoginPromise = null;
                    return;
                }

                let cardList = await this.availableCards();
                if (!Array.isArray(cardList) || cardList.length === 0) {
                    throw new Error("Takılı akıllı kart bulunamadı.");
                }
                const preferredSerial: string | null = store.getters.selectedCardSerial ?? null;
                // Yeni yapıda kart kimliği certificate.certificateId
                let card = cardList.find((c: any) => c?.certificate?.certificateId === preferredSerial);
                if (!card) {
                    card = cardList[0];
                }
                store.commit('setSelectedCardSerial', card.certificate.certificateId);
                await axios.post('https://imza.eicrapro.com:6090/focus');

                // TCKN kontrolü - yeni yapıda subjectSerial düz metin (base64 değil)
                const certTcknRaw: string = card.certificate.subjectSerial ?? '';
                console.log('Beta Login - Sertifika TCKN:', certTcknRaw);
                const sessionTcknRaw = this.ensureTcknInSession();
                console.log('Beta Login - SessionStorage TCKN:', sessionTcknRaw);

                const normalize = (v: string | null | undefined) => v ? v.replace(/\D/g, '') : null;
                const sessionTckn = normalize(sessionTcknRaw);
                const certTckn = normalize(certTcknRaw);
                console.log("certTckn", certTckn);

                if (sessionTckn && certTckn && sessionTckn !== certTckn) {
                    console.error('TCKN uyuşmazlığı! SessionStorage:', sessionTckn, 'Sertifika:', certTckn);
                    throw {type: 'unauthorized', message: 'İzinsiz İmza'};
                } else if (!sessionTckn) {
                    console.warn('SessionStorage\'da TCKN bulunamadı, kontrol atlanıyor');
                } else {
                    console.log('TCKN kontrolü başarılı');
                }

                let pinCodes = this.getPinCodes();
                // Yeni yapıda seri no: certificate.certificateId (düz metin)
                const currentSerial = card.certificate.certificateId;
                console.log("currentSerial", currentSerial);
                let cardPin = pinCodes.find((item: any) => item.cardSerialNumber === currentSerial);
                console.log("cardPin", cardPin);

                let pinCode: string;
                if (!cardPin) {
                    const formValues = await promptForPin({
                        ownerName: card.certificate.subject,
                        title: 'İmza Pin Kodu',
                        rememberLabel: 'Otomatik oturum aç',
                        minLen: 4,
                        maxLen: 12
                    });

                    if (!formValues) {
                        throw new Error('İmza işlemi iptal edildi');
                    }

                    pinCode = formValues.pin;
                    const autoLoginEnabled = formValues.remember;

                    console.log('Otomatik oturum aç:', autoLoginEnabled);

                    pinCodes.push({
                        cardOwnerName: card.certificate.subject,
                        cardSerialNumber: currentSerial,
                        pinCode: pinCode,
                        autoLogin: autoLoginEnabled
                    });
                    this.setPinCodes(pinCodes);
                } else {
                    pinCode = cardPin.pinCode;
                }

                // UYAP sabit challenge metni (HAR'dan alındı)
                const UYAP_SIGN_CONTENT = 'QWRhbGV0IEJha2FubMSxxJ/EsSBCaWxnaSDEsMWfbGVtIEdlbmVsIE3DvGTDvHJsw7zEn8O8IHRhcmFmxLFuZGFuIGdlbGnFn3RpcmlsZW4gdXlndWxhbWF5YSBlLWltemEgZ2lyacWfIHlhcG1hayBpc3RpeW9ydW0u';

                // Yeni imzalama uygulaması ile imzala
                let signResponse: any;
                try {
                    signResponse = await axios.post(newSignerUrl + '/api/v1/signature/sign', {
                        certificateId: card.certificate.certificateId,
                        password: pinCode,
                        content: UYAP_SIGN_CONTENT
                    });
                } catch (e) {
                    // PIN hatası kontrolü
                    if (e?.response?.status === 401 || e?.response?.data?.metadata?.STATUS === 'WRONG_PIN') {
                        pinCodes = pinCodes.filter((item: any) => item.cardSerialNumber !== currentSerial);
                        this.setPinCodes(pinCodes);
                        throw {type: 'pin', message: 'PIN Yanlış', serialNumber: currentSerial};
                    }
                    throw e;
                }

                const signedData = signResponse?.data?.data?.signedData;
                const txId = signResponse?.data?.data?.txId;
                if (!signedData || !txId) {
                    throw new Error('İmzalama başarısız: İmzalanmış veri veya txId alınamadı.');
                }

                // HAR'a göre: GET web1.uyap?signature=...&txId=...
                let newAxios = new Axios({
                    withCredentials: true,
                });
                await newAxios.get(avukatUyapUrl + '/clearCookies');
                const web1Res = await newAxios.get(avukatUyapUrl + '/web1.uyap', {
                    params: {
                        signature: signedData,
                        txId: txId
                    }
                });
                window.sessionStorage.setItem("JSESSIONID", web1Res.headers.cookie ?? '');

                await newAxios.post(avukatUyapUrl + '/login.uyap', {});
                await axios.post('https://imza.eicrapro.com:6090/focus');
                this.betaLoginPromise = null;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("ERROR", e);
                if (e?.type == "pin")
                    localStorage.removeItem(e.serialNumber);
                if (e?.type == "unauthorized") {

                    this.sendImzaMessage({
                        title: "İzinsiz İmza",
                        text:  "Hesabınızda kayıtlı TC kimlik numarası ile e-İmza kartındaki TC kimlik numarası uyuşmamaktadır. Lütfen kendi hesabınızla giriş yapın ve size ait e-İmza kartını kullanın. Sorunun devam ettiğini düşünüyorsanız, Cloud ekranında Ctrl + Shift + R tuşlarına basarak sayfayı yenileyebilir ve tekrar deneyebilirsiniz.",
                        icon: "warning",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });

                } else if (e.message && e.message.includes("Failed to execute 'atob'")) {
                    this.sendImzaMessage({
                        title: "İmza Kartı Bulunamadı",
                        text:  "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun.",
                        icon: "warning",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });
                } else {
                    this.sendImzaMessage({
                        title: "UYAP oturumu açılırken bir hata oluştu.",
                        text:  e.message,
                        icon: "error",
                        allowOutsideClick: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Tamam'
                    });
                }
                this.imzaLoginWaiting = false;
                this.betaLoginPromise = null;
                //throw new Error(e.message);
            } finally {
                // İşlem bittiğinde lock’u sıfırla
                this.betaLoginPromise = null;
            }
        })();
        // Promise’i döndür
        return this.betaLoginPromise;
    }

    async fastBetaLogin() {
        try{
            let pinCodes = this.getPinCodes();
            //@ts-ignore
            let cardPin = pinCodes.find((item: any) => item.cardSerialNumber === store.getters.selectedCardSerial);
            if(cardPin){
                if(cardPin.autoLogin === true){
                    await this.betaLogin();
                }
            }
        }catch (e) {
            this.sendImzaMessage({
                title: "OTO LOGIN ERROR",
                text:  e.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Tamam'
            });
        }
    }

    async mobilImzaLogin(formData: any,appCode: "avukat" | "arabulucu" = "avukat") {
        const response = await axios({
            url: imzaciUrl + "/cloud-login/mobilImzaLogin",
            method: "POST",
            data: {
                credentials: formData,
                appCode: appCode,
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            responseType: "json",
        });
        return response.data;
    }

    async eDevletMobilImzaLogin(formData: {gsm: string,operator: string,tcno: string}) {
        const response = await axios({
            url: imzaciUrl + "cloud-login/edevletMobilImza",
            method: "POST",
            data: formData,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            responseType: "json",
        });
        let cookies = response.data.cookies;
        console.log("cookies",cookies);
        return response.data;
    }

    fastLogin(uyapPlatform: number) {
        return new Promise((s, f) => {
            if (this.imzaLoginWaiting == true)
                return f({message: this.waitingFailMessage});
            this.imzaLoginWaiting = true;
            axios.post(imzaciUrl + 'xml/sessionFast').then((response) => {
                const cookieSetUrl = proxyBaseUrl + uyapPlatform.toString() + '/cookie?' + window.atob(response.data) + ';SameSite=None;Secure';
                axios.post(cookieSetUrl).then(() => {
                    this.imzaLoginWaiting = false;
                    return s(response.data);
                });
            }).catch((e) => {
                if (e.message != this.waitingFailMessage) {
                    this.imzaLoginWaiting = false;
                }
                f(e);
            });
        });
    }

    mesajImzala() {
        const myXml = '<root>' +
            '<auth><token></token></auth>' +
            '<data><message>Emre deneme imzala</message></data>' +
            '</root>';
        //readResult = reader.result.split(',')[1];
        axios.post(imzaciUrl + "xml/mesajImzala", myXml, {
            headers: {
                "Content-Type": "application/xml;charset=UTF-8"
            }
        })
    }



    icrapro80VeriAktar(dosyaEsasNo: any, icraDairesi: any, kartId: any, klasor: any) {
        return new Promise((resolve, reject) => {
            const xml = "<dosyaEsasNo>" + dosyaEsasNo + "</dosyaEsasNo><icraDairesi>" + icraDairesi + "</icraDairesi><kartId>" + kartId + "</kartId><icraproKlasor>" + klasor + "</icraproKlasor>";
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64(xml) + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + 'xml/setDosyaEsasNo', myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) =>{
                return resolve(data)
            }).catch((err)=>{
                return reject(err);
            });
        })
    }

    isMobilImza(): boolean {
        let loginType = window.localStorage.getItem("loginType");
        if(loginType){
            if(loginType == "mobil-imza")
                return true
        }
        return false;
    }

    dokumanImzala(data: Blob): Promise<any> {
        if (this.simulator) return Promise.resolve("");
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (typeof reader.result !== "string") {
                    reject(new Error("İmzalanacak dosya okunurken hata oluştu"));
                    return;
                }
                const b64Udf = reader.result.split(",")[1];
                const signPromise = this.isMobilImza()
                    ? this.mobilImzaDokumanImzala(b64Udf)
                    : this.eimzaDokumanImzala(b64Udf);
                signPromise.then(resolve).catch(reject);
            };
            reader.onerror = () => reject(reader.error || new Error("Dosya okunamadı"));
            reader.readAsDataURL(data);
        });
    }

    getMobilImzaCredentials(){
        let credentials = window.localStorage.getItem("credentials");
        if(credentials){
            return  JSON.parse(credentials);
        }else {
            throw new Error("Mobil kullanıcı bilgisi bulunamadı !")
        }
    }

    async mobilImzaDokumanImzala(b64Udf: any): Promise<any>{
        try{
            let credentials = this.getMobilImzaCredentials();
            let result = await axios.post(avukatUyapUrl + "/mobileSign",{
                tcno: credentials.tcno,
                gsm: credentials.gsm,
                operator: credentials.operator,
                b64file: b64Udf
            });
            console.log("mobil IMZA SIGN RESULT",result);
            return result.data;
            //throw new Error("Mobil-Imza ile döküman imzalama işlemi başarısız.")
        }catch (e) {
            throw new Error("Mobil-Imza ile döküman imzalama işlemi başarısız. > "+ e.message)
        }
    }

    async eimzaDokumanImzala(b64Udf: any): Promise<any> {
        try {
            const myXml =
                "<root>" +
                "<auth><token></token></auth>" +
                "<data><code>" +
                b64Udf +
                "</code></data>" +
                "</root>";
            const response = await axios.post(imzaciUrl + "xml/b64imzala", myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8",
                },
            });
            const parsed = await new Promise<string>((resolve, reject) => {
                xml2js.parseString(response.data, {explicitArray: false}, (error: any, result: any) => {
                    if (error) reject(error);
                    else resolve(result.root.file);
                });
            });
            return parsed;
        } catch (err) {
            if (err.response) {
                xml2js.parseString(err.response.data, {explicitArray: false}, (_error: any, result: any) => {
                    app.$toast.error("Hata Kodu " + err.response.status + ": " + (result?.root?.error_title || ""));
                });
            } else if (err.request) {
                app.$toast.error("İmzacı bağlantı hatası.");
            } else {
                app.$toast.error("Bilinmeyen hata (" + err.message + ")");
            }
            throw err;
        }
    }



    getFileFromLocalPath(path: string) {
        return new Promise((resolve, reject) => {
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64("<path>" + path + "</path>") + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + "xml/getXmlContent", myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) => {
                let replacedData = String(data.data).replace(/\n/g, "");
                let parseString = xml2js.parseString;
                parseString(replacedData, {explicitArray: false}, (error: Error | null, jsonData: any) => {
                    if (error) {
                        return reject(error);
                    }
                    if (typeof jsonData.root.file != "undefined") {
                        return resolve(jsonData.root);
                    } else {
                        return reject({message: "Dosya bulunamadı !"});
                    }
                });
            }).catch(err => {
                return reject(err);
            })
        });
    }

    serialize(obj: any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

}

export default function ImzaClientPlugin(Vue: typeof _Vue): void {
    // do stuff with options
    Vue.prototype.$imza = new ImzaClient();
}
